<ion-header>
    <ion-toolbar class="header-color">
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title class="toolbar-title">Reset Password</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
	<div class="reset-success">
		<ion-icon name="checkmark-circle-outline"></ion-icon>
		<p>Password has been changed successfully.</p>
	   	<ion-button
            class="login-button"
            color="secondary"
            disabled="false"
            (click)="gotoLoginPage()"
    	>
            LOGIN
        </ion-button>
	</div>
</ion-content>
